import {
  Box,
  Button,
  Fade,
  FormControl,
  Image,
  Input,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../content/Content";
import {  NavLink } from "react-router-dom";
import { useState } from "react";

const HeaderJifu = () => {
  const [searchOpen, setSearch] = useState(false);
  const [langDrop, setLangDrop] = useState(false);
  const [profile, setProfile] = useState(false);

  const Lang = [
    {
      name: "English",
      flag: Img.us,
    },
    {
      name: "English (uk)",
      flag: Img.uk,
    },
    {
      name: "France ",
      flag: Img.france,
    },
    {
      name: "Germany",
      flag: Img.germany,
    },
  ];
  return (
    <div>
      {/* Header */}
      <Box w="95%" margin={"auto"} className="desktop-version" position='absolute' left='0' right='0' top='0' py="15px">
        <VStack maxW={"100%"} w={"100%"} flexDir={"row"} alignItems={"center"}>
          {/* Logo */}
          <Stack w="50%">
            <UnorderedList display="flex">
              <ListItem listStyleType="none" my="10px" mx="10px">
                <NavLink to="travel">
                  <Box
                    display="flex"
                    alignItems="center"
                    p="8px 25px"
                    borderRadius="12px"
                  >
                    <Text
                      mx="8px"
                      fontFamily="'Roboto', sans-serif"
                      fontWeight="500"
                      fontSize={"20px"}
                      color="rgba(149, 151, 171, 1)"
                    >
                      Travel
                    </Text>
                  </Box>
                </NavLink>
              </ListItem>
              <ListItem listStyleType="none" my="10px">
                <NavLink to="health">
                  <Box
                    display="flex"
                    alignItems="center"
                    p="8px 25px"
                    borderRadius="12px"
                  >
                    <Text
                      mx="8px"
                      fontFamily="'Roboto', sans-serif"
                      fontWeight="500"
                      fontSize={"20px"}
                      color="rgba(149, 151, 171, 1)"
                    >
                      Health
                    </Text>
                  </Box>
                </NavLink>
              </ListItem>
              <ListItem listStyleType="none" my="10px">
                <NavLink to="university">
                  <Box
                    display="flex"
                    alignItems="center"
                    p="8px 25px"
                    borderRadius="12px"
                  >
                    <Text
                      mx="8px"
                      fontFamily="'Roboto', sans-serif"
                      fontWeight="500"
                      fontSize={"20px"}
                      color="rgba(149, 151, 171, 1)"
                    >
                      University
                    </Text>
                  </Box>
                </NavLink>
              </ListItem>
            </UnorderedList>
          </Stack>

          {/* menu bar */}
          <Stack w="50%" justifyContent={"end"} position={"relative"}>
            <Box
              display={"flex"}
              justifyContent={"flex-end"}
              alignItems="center"
            >
              {/* Search- bar */}
              <Stack>
                <FormControl
                  position={"relative"}
                  display="flex"
                  alignItems="center"
                  margin="0 10px"
                >
                  <Fade in={searchOpen}>
                    <Input
                      type="text"
                      bg="transparent"
                      border={
                        searchOpen
                          ? "1.5px solid rgba(149, 151, 171, 1)"
                          : "none"
                      }
                      borderRadius="25px"
                      padding={searchOpen ? "12px 40px" : "0"}
                      color="#fff"
                      w={searchOpen ? "200px" : "0"}
                      onClick={() => setSearch(!searchOpen)}
                    />
                  </Fade>
                  <Image
                    src={Img.search}
                    alt="search"
                    position={searchOpen ? "absolute" : ""}
                    left="10px"
                    top="10px"
                    cursor="pointer"
                    onClick={() => setSearch(!searchOpen)}
                  />
                </FormControl>
              </Stack>

              {/* language bar */}
              <Stack position="relative" w="115px">
                <Box
                  marginTop={"10px"}
                  display="flex"
                  alignItems="center"
                  cursor="pointer"
                  justifyContent="center"
                  onClick={() => setLangDrop(!langDrop)}
                >
                  <Image
                    src={Img.us}
                    alt="photo"
                    w="28px"
                    h="28px"
                    borderRadius="25"
                  />
                  <Text
                    fontSize="14px"
                    fontWeight="400"
                    margin="0 6px"
                    color="rgba(0, 0, 0, 1)"
                  >
                    English
                  </Text>
                </Box>
                <Fade in={langDrop}>
                  <Box
                    h="auto"
                    top="44px"
                    position="absolute"
                    left={"-25px"}
                    borderRadius="15px"
                    bg="white"
                    shadow='lg'
                    width='170px'
                    p="10px"
                  >
                    <UnorderedList
                      padding="0"
                      margin="0"
                      listStyleType="none"
                      display="flex"
                      alignItems="flex-start"
                      justifyContent={"center"}
                      flexDir="column"
                    >
                      {Lang.map((items) => {
                        return (
                          <ListItem padding="10px 10px" margin={"5px 0"}>
                            <Box
                              display="flex"
                              alignItems="center"
                              cursor="pointer"
                              w="100%"
                            >
                              <Image
                                src={items.flag}
                                alt="photo"
                                w="28px"
                                h="28px"
                                borderRadius="25"
                              />
                              <Text
                                fontSize="14px"
                                fontWeight="400"
                                margin="0 6px"
                                color="#000"
                              >
                                {items.name}
                              </Text>
                            </Box>
                          </ListItem>
                        );
                      })}
                    </UnorderedList>
                  </Box>
                </Fade>
              </Stack>
              {/* Notification */}
              <Stack>
                <Box padding={"0 8px"}>
                  <Image src={Img.notification} />
                </Box>
              </Stack>
              <Stack>
                <Box
                  padding={"0 8px"}
                  cursor={"pointer"}
                  onClick={() => setProfile(!profile)}
                >
                  <Image src={Img.profile} />
                </Box>
              </Stack>
              {profile ? (
                <Box
                  position="absolute"
                  top="70px"
                  borderRadius="10px"
                  bg={"#EDF2F7"}
                  py="15px"
                >
                  <Button w="100%">Profile</Button>
                  <Button w="100%">Setting</Button>
                  <Button w="100%">Logout</Button>
                </Box>
              ) : (
                ""
              )}
            </Box>
          </Stack>
        </VStack>
      </Box>
    </div>
  );
};

export default HeaderJifu;
